import React from 'react';
import { redirect } from '../../../helper/redirectHelper';
import { Container, SubTitle, Title } from './DataCoverage.styled';
import Terms from '../../components/common/Terms';

const DataCoveragePage = () => {
    const domain = window.location.origin;

    return (
        <Container className="container">
            <Title data-testid="title">Data coverage</Title>
            <SubTitle data-testid="applicationTitle">Coverage of European patent (EP) applications</SubTitle>
            <p>Linked open EP data contains the bibliographic data of:</p>
            <ul>
                <li>EP applications and publications; and</li>
                <li>and the related applications and publications from other patent authorities.</li>
            </ul>
            <p style={{ marginTop: '-17px' }}>In other words, it covers:</p>
            <p>
                <h4>Applications</h4>
            </p>
            <ul>
                <li>EP applications</li>
                <li>International (PCT) of EP applications</li>
                <li>Priorities of EP applications</li>
                <li>Non-EP applications in the same simple patent family as an EP application</li>
            </ul>
            <p>
                <h4>Publications</h4>
            </p>
            <ul>
                <li>EP publications</li>
                <li>
                    Publications that an EP publication cites directly or indirectly (indirectly means via non-patent
                    literature)
                </li>
                <li>
                    Non-EP publications where the application is in the same simple patent family as an EP application
                </li>
            </ul>
            <p>The data is updated weekly.</p>
            <p>
                <h4>Notes:</h4>
            </p>
            <ul>
                <li>
                    For EP documents, coverage includes most of the bibliographic data available. For{' '}
                    <b>non-EP documents</b>, coverage is limited to basic patent identification information.
                </li>
                <li>
                    <b>Data directly linked to EP publications</b> – except citations and IPC classifications – is
                    provided as it was published. <b>All other data</b> may be subject to updates, for example because
                    of a change in IPC or CPC classification or corrections.
                </li>
                <li>
                    The data does not include citations <b>provided by applicants</b> because they are typically of poor
                    quality. However, it does include <b>citations from all other sources</b> – for example from search,
                    examination, opposition and third-party observations.
                </li>
                <li>
                    All EP publications have three
                    <b>patent:titleOfInvention</b> properties, one for each of the EPO's three official languages. They
                    have the language tags @en, @de and @fr.
                </li>
                <li>
                    All EP publications have three <b>patent:representation</b> properties, one for each of the HTML,
                    XML and PDF representations – with the exception of Euro-PCT publications published by WIPO and not
                    republished by the EPO, which have HTML and XML representations only. See, for example,{' '}
                    <a data-testid="examplePublicaton" href={redirect('data/publication/EP/3102070/A1/-')}>
                        https://data.epo.org/data/publication/EP/3102070/A1/-
                    </a>
                </li>
                <li>
                    The <b>simple family</b> is also called the "DOCDB family". All applications are members of exactly
                    one simple family. Most families have one representative member.
                </li>
                <li>
                    The <b>rdfs:seeAlso</b> property links EP patent RDF resources to RDF resources from other offices.
                    However, currently the only such links are to applications from the Korean Patent Office.
                </li>
            </ul>
            <p style={{ marginTop: '-17px' }}>
                For more details on the linked open EP application data, see the{' '}
                {domain.match('localhost') ? <a data-testid="applicationData" href="/documentation/patent-ontology-overview">
                    patent ontology overview
                </a> : <a data-testid="applicationData" href="/linked-data/documentation/patent-ontology-overview">
                    patent ontology overview
                </a>}{' '}
                page
            </p>
            <SubTitle data-testid="classificationTitle">
                Coverage of the Cooperative Patent Classification (CPC)
            </SubTitle>
            <p>Linked open EP data contains the most-relevant data from the CPC.</p>
            <p>
                {' '}
                The CPC is a patent classification scheme with about 250 000 classifications covering all technical
                fields. More information is available on the CPC website at{' '}
                <a data-testid="cpcWebsite" href="https://www.cooperativepatentclassification.org">
                    https://www.cooperativepatentclassification.org
                </a>{' '}
                .
            </p>
            <p>
                The data is updated whenever a new version of the CPC comes into force – typically three to five times a
                year.
            </p>
            <p>
                For more details on the linked open CPC data, see the{' '}
                {domain.match('localhost') ? <a href="/documentation/cpc-ontology-overview">CPC ontology overview</a> : <a href="/linked-data/documentation/cpc-ontology-overview">CPC ontology overview</a>}
                 page.
            </p>{' '}
            <Terms />
        </Container>
    );
};
export default DataCoveragePage;